<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-autocomplete
        v-model="value"
        :md-options="customers"
        @md-changed="getCustomers"
        @md-selected="customerSelected"
      >
        <label>Customers</label>
        <template slot="md-autocomplete-item" slot-scope="{ item }"
          >{{ item.full_name }} ({{ item.email }})</template
        >
      </md-autocomplete>
    </div>
    <div class="md-layout-item"></div>
  </div>
</template>
<script>
import customerApi from "@/services/api/customer";
import _debounce from "lodash/debounce";

export default {
  components: {},

  data: () => ({
    value: null,
    customers: []
  }),

  methods: {
    getCustomers: _debounce(function(searchTerm) {
      this.performSearch(searchTerm);
    }, 500),

    performSearch(searchTerm) {
      this.customers = !searchTerm
        ? []
        : customerApi
            .findCustomer(searchTerm)
            .then(resp => resp.data.customers);
    },

    customerSelected(customer) {
      this.value = customer.full_name;
    }
  }
};
</script>
<style></style>
